/**
 * filter for the remaining label - will replace with word passed in from the template
 */
angular.module('bookingApp').filter('remainingLabel', function(){
    return function(input, remainingLabel){
        if(!remainingLabel){
            return input;
        }
        return remainingLabel;
    }
});